module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "list"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fronthead"
  }, [_vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/005_map#list0"
    }
  }, [_c('i', [_vm._v("Map of the River Ouse")]), _vm._v(", by Helen Macdonald")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/010_il1#list1"
    }
  }, [_c('i', [_vm._v("The River Ouse")]), _vm._v(". Photograph by the author.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/012_il2#list2"
    }
  }, [_c('i', [_vm._v("Gideon Algernon Mantell")]), _vm._v(", by William Turner Davey, published by L. Buck, after Pierre Athasie Théodore Senties, and John Jabez Edwin Mayall. Mezzotint,\n  circa 1850. Copyright © National Portrait Gallery, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/014_il3#list3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Upper Hell")]), _vm._v(", by C. W. Scott-Giles, from "), _c('i', [_vm._v("Hell")]), _vm._v(", book one of Dante’s "), _c('i', [_vm._v("Divine Comedy")]), _vm._v(", translated by Dorothy L. Sayers and first published by\n  Penguin in 1949.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/016_il4#list4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Simon de Montfort, Earl of Leicester")]), _vm._v(", circa 1231."), _c('br'), _vm._v("\n  Copyright © Hulton Archive/Getty Images")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/018_il5#list5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The reconstructed skull of ‘Piltdown Man’")]), _vm._v(", circa 1950."), _c('br'), _vm._v("\n  Copyright © Popperphoto/Getty Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/020_il6#list6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Virginia Woolf")]), _vm._v(". Copyright © Press Association")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/022_il7#list7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Leonard Woolf")]), _vm._v(", first published alongside ‘Do We Read Better Books in Wartime’ in the "), _c('i', [_vm._v("Picture Post")]), _vm._v(", 1944. Copyright © Felix Man and\n  Kurt Jutton/Picture Post/Hulton Archive/Getty Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/024_il8#list8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lieutenant Ackery’s Crash")]), _vm._v(". Copyright © Henry Ross Alderson/climb-out.co.uk.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-121707b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/008_loi.vue
// module id = 81
// module chunks = 0